import icons from "../helpers/icons";
import React from "react";
import {
    Link
} from 'react-router-dom'

const Foreldre = (props) => {
    const {far, mor, labelFar, labelMor} = props;


    const renderFar = () => {
        if (far !== null) {
            return (
                <Link to={`/hund?id=${far.hundId}`}>
                    <div className="dogweb-sub-card">
                            <div className="arrow">
                                <img className="icon" src={icons.arb} alt="" />
                            </div>
                            <h3>{labelFar}</h3>
                        {
                            far.tittel1 !== null &&
                            <div className="clip-text"><img className="icon score-black" src={icons.score} alt="" /> {far.tittel1}</div>
                        }
                        <div className="clip-text"><strong>{far.navn}</strong></div>
                        { far.farge && <div><span className="ledetekst">Farve:</span> {far.farge}</div> }
                        <div><span className="ledetekst">Regnr:</span> {far.hundId}</div>
                    </div>
                </Link>
            );
        } else {
            return (
                <div className="dogweb-sub-card">
                    <div className="arrow">
                        <img className="icon" src={icons.arb} alt="" />
                    </div>
                    <h3>{labelFar}</h3>
                    Det er ikke registrert noen {labelFar}
                </div>
            );
        }
    };

    const renderMor = () => {
        if (mor !== null) {
            return (
                <Link to={`/hund?id=${mor.hundId}`}>
                    <div className="dogweb-sub-card">
                            <div className="arrow">
                                <img className="icon" src={icons.arb} alt="" />
                            </div>
                            <h3>{labelMor}</h3>
                        {
                            mor.tittel1 !== null &&
                                <div className="clip-text"><img className="icon score-black" src={icons.score} alt="" /> {mor.tittel1}</div>
                        }
                        <div className="clip-text"><strong>{mor.navn}</strong></div>
                        { mor.farge && <div><span className="ledetekst">Farve:</span> {mor.farge}</div> }
                        <div><span className="ledetekst">Regnr:</span> {mor.hundId}</div>
                    </div>
                </Link>
            )
        } else {
            return (
                <div className="dogweb-sub-card">
                    <div className="arrow">
                        <img className="icon" src={icons.arb} alt="" />
                    </div>
                    <h3>{labelMor}</h3>
                    Det er ikke registrert noen {labelMor}
                </div>
            )
        }

    };

    return (
        <div className="content">
            <div className="parents-2">
                {renderFar()}
                {renderMor()}
            </div>
        </div>
    );
};



export default Foreldre;